import PageMeta from "../../components/common/PageMeta";
import FormGenerator from "../../plugins/formGenerator/form";
import { useForm, FormProvider } from "react-hook-form";

export default function LoadOrders() {
  const methods = useForm();
  return (
    <>
      <PageMeta title="Assign Load | Admin Carriers" description="" />
      <div>
        <FormProvider {...methods}>
          <FormGenerator
            formId="loadorders"
            formIntData={{
              detailsPage: "details",
              idShow: true,
            }}
          />
        </FormProvider>
      </div>
    </>
  );
}
